import { render } from "./NewColisListePage.vue?vue&type=template&id=32b58a14&ts=true"
import script from "./NewColisListePage.vue?vue&type=script&lang=ts"
export * from "./NewColisListePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__